/* src/app/main/data-policy/data-policy.component.scss */
.policy p {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  font-size: medium;
}
/*# sourceMappingURL=data-policy.component.css.map */
